import {lazy,Suspense} from 'react';
import {Loading} from './Common';
import type {Trade, DisplayUsdQuote, MarketHistory, NearV1Market} from '../../../../packages/sdk/src';
const MarketChart=lazy(()=>import('./KlineMarketChart'));
export function CandleChart(props:{id:string;symbol:string;supply?:string;graduationPriceBNB?:string|null;usdQuote?:DisplayUsdQuote|null;revision?:number;trades?:Trade[];nativeMarket?:NearV1Market;exampleHistory?:(range:string,interval:number)=>MarketHistory}){
 return <Suspense fallback={<Loading label="Loading market chart"/>}><MarketChart key={props.id+':'+props.symbol} {...props}/></Suspense>;
}
